
import React from 'react';

const SecretarialHeader = () => {
  return (
    <div className="flex justify-between items-center">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Secretarial Compliance</h1>
        <p className="text-muted-foreground">
          Manage secretarial compliance, statutory filings, and corporate governance documentation
        </p>
      </div>
    </div>
  );
};

export default SecretarialHeader;
